import { render, staticRenderFns } from "./TableItem.vue?vue&type=template&id=23073014&lang=pug&functional=true"
import script from "./TableItem.vue?vue&type=script&lang=js"
export * from "./TableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports